import { render, staticRenderFns } from "./LayerExtraAttributesSummary.vue?vue&type=template&id=6c0eeafc&scoped=true"
import script from "./LayerExtraAttributesSummary.vue?vue&type=script&lang=js"
export * from "./LayerExtraAttributesSummary.vue?vue&type=script&lang=js"
import style0 from "./LayerExtraAttributesSummary.vue?vue&type=style&index=0&id=6c0eeafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0eeafc",
  null
  
)

export default component.exports